import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { computed } from 'vue'

import BusyIndicator from '@/components/common/BusyIndicator.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormButton',
  props: {
  isPrimary: {
    type: Boolean,
    default: true,
  },

  isSecondary: {
    type: Boolean,
    default: false,
  },

  isBusy: {
    type: Boolean,
    default: false,
  },

  isDisabled: {
    type: Boolean,
    default: false,
  },

  isSmall: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const buttonClassList = computed<object>((): object => {
  return {
    'is-primary': !props.isSecondary,
    'is-secondary': props.isSecondary && !props.isPrimary,
    'is-small': props.isSmall,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["form-button", buttonClassList.value]),
    disabled: __props.isBusy || __props.isDisabled
  }, [
    (__props.isBusy)
      ? (_openBlock(), _createBlock(BusyIndicator, { key: 0 }))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 10, _hoisted_1))
}
}

})